import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Header } from "@/components/Header";
import { DoorwayCard } from "@/components/DoorwayCard";
import { ComingSoonModal } from "@/components/ComingSoonModal";
import { Marquee } from "@/components/Marquee";
import { Footer } from "@/components/Footer";
import { DOORWAYS, NAV_ROOMS } from "@/data/doorways";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const gridVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.55 } },
};

export default function Home() {
  const [activeRoom, setActiveRoom] = useState(null);

  const openNavRoom = (key) => setActiveRoom(NAV_ROOMS[key]);

  const subscribe = async (email) => {
    const { data } = await axios.post(`${API}/subscribe`, {
      email,
      interest: activeRoom.name,
      source: activeRoom.source,
    });
    return data;
  };

  return (
    <div className="min-h-screen overflow-x-clip" data-testid="home-page">
      <Header onOpenNavRoom={openNavRoom} />

      <main className="mx-auto w-full max-w-[1440px] px-4 pb-6 sm:px-6 lg:px-10">
        <motion.div
          className="grid grid-cols-1 gap-5 sm:gap-6 lg:grid-cols-2 lg:gap-7"
          variants={gridVariants}
          initial="hidden"
          animate="show"
        >
          {DOORWAYS.map((room, i) => (
            <DoorwayCard key={room.id} room={room} index={i} onOpen={setActiveRoom} />
          ))}
        </motion.div>
      </main>

      <Marquee />
      <Footer />

      <ComingSoonModal
        room={activeRoom}
        open={Boolean(activeRoom)}
        onClose={() => setActiveRoom(null)}
        onSubscribe={subscribe}
      />
    </div>
  );
}
